import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Typography } from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CommonButton from "../../../component/Button";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { CustomizeSpan } from "../../jobs/style";
import { platformBlackLogo } from "../../../utils/logo";

export default function AccountCreate() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const query = new URLSearchParams(useLocation().search);
  const email = query.get("email");

  const maskEmail = (email) => {
    const [name, domain] = email.split("@");
    if (name.length <= 2) {
      return `${name[0]}*@${domain}`;
    }
    return `${name[0]}${"*".repeat(name.length - 2)}${
      name[name.length - 1]
    }@${domain}`;
  };

  return (
    <CommonGrid2
      container
      alignItems={"baseline"}
      height={"100vh"}
      sx={{
        padding: {
          xs: "2rem 1rem",
          sm: "2rem 2rem",
          md: "2rem 4rem",
          lg: "2rem 0rem 2rem 6rem",
        },
      }}
      flexWrap={"wrap"}
    >
      <CustomDiv width="fit-content">
        {platformBlackLogo({height: "50px"})}
      </CustomDiv>
      <CommonGrid2 item size={12}>
        <Typography
          variant="h1"
          fontWeight="700"
          marginTop={"1.5rem"}
          sx={{
            fontSize: {
              xs: "30px",
              sm: "40px",
              md: "45px",
              lg: "50px",
            },
          }}
        >
          Thank you for your interest in TalAiro !
        </Typography>
        <Typography
          variant="h6"
          fontSize={"18px"}
          marginTop={"0.8rem"}
          lineHeight={"1.8rem"}
          color="#5B738B"
          sx={{
            fontSize: {
              xs: "14px",
              sm: "15px",
              md: "16px",
              lg: "18px",
            },
          }}
        >
          As soon as your account is created you will receive an email regarding
          your free trial.
          <br />
          Please check your email{" "}
          {email && (
            <CustomizeSpan
              fontWeight={600}
              color="#344054"
              style={{ fontFamily: "system-ui" }}
            >
              {maskEmail(email)} .
            </CustomizeSpan>
          )}
        </Typography>
        <CommonButton
          value="Back to Login"
          startIcon={loading ? "" : <ArrowBackIcon />}
          onClick={() => {
            setLoading(true);
            navigate("/auth/login");
          }}
          variant="contained"
          fontWeight={600}
          marginTop="2.5rem"
          padding={"10px 2rem"}
          gap={loading ? "10px" : "0px"}
          loading={loading}
          disabled={loading}
        />
      </CommonGrid2>
    </CommonGrid2>
  );
}
